import { coachPaths } from "../routes/coach";
import { findAJobPaths } from "../routes/find-a-job";
import { hireTalentPaths } from "../routes/hire-talent";
import {
  getProfile,
  setActivePublicPanel,
  setProfile,
  setToken,
} from "./pip";
import { normalizeHireTalentProfile } from "./hireTalentProfile";
import { createSocketConnection } from "../redux/features/chat/socket";
import { fetchfreelancerProfile } from "../redux/features/find-a-job/actions/authAction";
import { fetchHireTalentProfile } from "../redux/features/hire-talent/actions/authAction";
import {
  setIsFindAJobModal,
  setRegisterStep,
} from "../redux/features/find-a-job/reducers/authReducer";
import { setIsHireTalentModal } from "../redux/features/hire-talent/reducers/authReducer";

export const handlePostLoginFlow = ({
  response,
  dispatch,
  navigate,
  onClose,
}) => {
  const payload = response?.data || response;
  const token = payload?.token;
  const userData = payload?.userData;
  const close = () => {
    if (typeof onClose === "function") {
      onClose();
    };
  };
  if (!userData) return;
  if (userData?.role == "COACH") {
    setToken("coach", token);
    setActivePublicPanel("coach");
    setProfile("coach", userData);
    close();
    navigate(coachPaths?.CoachDashboard);
  } else if (userData?.role == "OPEN_TALENT") {
    setToken("freelancer", token);
    setActivePublicPanel("freelancer");
    setProfile("freelancer", userData);
    dispatch(fetchfreelancerProfile()).then((res) => {
      const data = res?.payload?.data;
      if (data) {
        const existing = getProfile("freelancer") || {};
        const merged = {
          ...data,
          full_name:
            data.full_name ||
            existing.full_name ||
            `${data.first_name || ""} ${data.last_name || ""}`.trim(),
          first_name: data.first_name || existing.first_name || data.full_name || "",
          last_name: data.last_name || existing.last_name || "",
        };
        setProfile("freelancer", merged);
      }
    });
    const freelancerSignupStep =
      Number(
        userData?.signup_step ||
          userData?.open_talent?.signup_step ||
          0
      ) || 0;
    const freelancerTalentType = String(
      userData?.open_talent?.talent_type || userData?.talent_type || ""
    ).toUpperCase();

    if (
      freelancerTalentType === "FREELANCER" &&
      freelancerSignupStep > 0 &&
      freelancerSignupStep < 5
    ) {
      close();
      dispatch(setRegisterStep(`profileStep${freelancerSignupStep}`));
      dispatch(setIsFindAJobModal(true));
      return;
    }

    if (
      freelancerTalentType === "FREELANCER" &&
      userData?.active_subscription === false
    ) {
      close();
      dispatch(setRegisterStep("subscription"));
      dispatch(setIsFindAJobModal(true));
      return;
    }

    close();
    dispatch(setIsFindAJobModal(false));
    dispatch(setRegisterStep(1));
    createSocketConnection(token);
    navigate(findAJobPaths?.Dashboard);
  } else if (userData?.role == "HIRE_TALENT") {
    setToken("hire-talent", token);
    setActivePublicPanel("hire-talent");
    setProfile("hire-talent", userData);
    dispatch(fetchHireTalentProfile({ force: true })).then((res) => {
      const data = res?.payload?.data;
      const existing = getProfile("hire-talent") || {};
      const normalized = normalizeHireTalentProfile({
        ...existing,
        ...(data || {}),
        ...(userData?.hiretalent || {}),
      });
      setProfile("hire-talent", normalized);
      dispatch(setIsHireTalentModal(false));
      createSocketConnection(token);
      navigate(hireTalentPaths?.Dashboard);
      close();
    });
  };
};
